







































import {
  computed,
  defineComponent,
  PropType,
  toRefs
} from '@nuxtjs/composition-api'
import { AuditRequest } from '~/models/audit/request'
import CBadge from '~/components/shared/configurable/badge/CBadge.vue'
import { useDeps } from '~/compositions/dependency-container'
import AuditRequestService from '~/services/audits/AuditRequestService'
import CPing from '~/components/shared/configurable/timeline/CPing.vue'
import { useNamespacedStore } from '~/compositions/store'
import { USER_NS, UserState } from '~/store/modules/shared/user/state'
import { isAfter, parseDate, timeDistanceFromNow } from '~/utils/date'

export default defineComponent({
  components: { CPing, CBadge },
  props: {
    auditRequest: {
      type: Object as PropType<AuditRequest>,
      required: true
    },
    fullWidth: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  setup(props) {
    const { auditRequest } = toRefs(props)

    const status = computed(() => auditRequest.value.currentStatus)

    const [auditRequestService] = useDeps(AuditRequestService)

    const variant = computed(() => {
      if (auditRequestService.statusIsSuccess(status.value.status)) {
        return 'success'
      } else if (auditRequestService.statusIsFail(status.value.status)) {
        return 'danger'
      }
      return 'info'
    })

    const { getters: userGetters } = useNamespacedStore<UserState>(USER_NS)
    const isAuditsUser = computed(() => userGetters('isAuditsUser'))

    const shouldPing = computed<boolean>(() => {
      if (status.value?.status) {
        return (
          auditRequestService.getStatusVariant(
            auditRequest.value.currentStatus.status,
            0
          ) === 'info'
        )
      }
      return false
    })

    const expirationDateFromNow = computed(() => {
      return timeDistanceFromNow(
        parseDate(auditRequest.value.expirationDate, 'd/M/yyyy HH:mm')
      )
    })

    const hasExpired = computed(() => {
      return !isAfter(
        parseDate(auditRequest.value.expirationDate, 'd/M/yyyy HH:mm'),
        Date.now()
      )
    })

    const showExpiration = computed(() => {
      return isAuditsUser.value && variant.value === 'info'
    })
    return {
      variant,
      auditRequestService,
      shouldPing,
      isAuditsUser,
      expirationDateFromNow,
      showExpiration,
      hasExpired
    }
  }
})
